import { useAuth } from "hooks/useAuth"
import { enRules } from "interfaces/IUser"
import { ReactNode } from "react"

interface IPermissionGate {
  permissions: enRules[]
  userPermissions?: enRules[]
  children: ReactNode
}

export const PermissionGate = ({ permissions, children }: IPermissionGate) => {
  const {
    user: { rules },
  } = useAuth()

  if (permissions.some(permission => rules.includes(permission)) || !permissions.length) {
    return <>{children}</>
  }

  return null
}
